"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@matsuricon/ui/button";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { SiteWordmark } from "@/components/site-shell/branding/site-wordmark";
import { DesktopNavigation } from "./desktop-navigation";
import { MobileNavigationSheet } from "./mobile-navigation-sheet";
import { buildNavigation } from "./navigation-data";
export function SiteNav(t0) {
  const $ = _c(13);
  const {
    currentYear
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== currentYear) {
    t1 = buildNavigation(currentYear);
    $[0] = currentYear;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const navItems = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link aria-label="Matsuricon home" href="/" className="flex min-h-11 shrink-0 items-center"><SiteWordmark /></Link>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== navItems || $[4] !== pathname) {
    t3 = <DesktopNavigation items={navItems} pathname={pathname} />;
    $[3] = navItems;
    $[4] = pathname;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button asChild={true} size="lg" className="hidden shrink-0 font-sans text-sm tracking-normal xl:inline-flex"><Link href="/registration/attend">Register Now</Link></Button>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== navItems || $[8] !== pathname) {
    t5 = <MobileNavigationSheet items={navItems} pathname={pathname} />;
    $[7] = navItems;
    $[8] = pathname;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <header className="sticky top-0 z-overlay border-b border-border/70 bg-background/85 font-sans backdrop-blur-xl supports-backdrop-filter:bg-background/70"><div className="section-shell flex h-18 items-center justify-between gap-6">{t2}{t3}{t4}{t5}</div></header>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}